import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import Fotter from "../components/Fotter";
import { BASE_URL } from "./Config";
import axios from "axios";
import { Link } from "react-router-dom";
import Form from "./Form";

export default function Help() {
  const [help, sethelp] = useState("");

  useEffect(() => {
    axios
      .get(`${BASE_URL}/get_help.php?t=${Date.now()}`)
      .then((res) => {
        if (res.data.success) {
          sethelp(res.data.data);
          //   console.log(res.data.data);
        } else {
          console.error("API response error:", res.data.message);
        }
      })
      .catch((err) => console.error("API request failed:", err));
  }, []);

  return (
    <>
      <Navbar />

      <div className="page-info">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="info">
                <Link to="/">
                  <p>HOME</p>
                </Link>
                <span> /</span>
                <Link to="/">
                  <p>FASTTRADE</p>
                </Link>
                <span> /</span>
                <p>HELP SUPPORT</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="page-settings">
        <div className="container">
          <div
            className="row"
            dangerouslySetInnerHTML={{
              __html: String(help.content),
            }}
          ></div>
        </div>
      </div>

      <Form />

      <Fotter />
    </>
  );
}
